import { AircraftTypeManagement } from "@/components/admin/AircraftTypeManagement";

export default function AircraftTypesPage() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold">Aircraft Type Management</h2>
        <p className="text-muted-foreground">Manage aircraft types for flights</p>
      </div>
      <AircraftTypeManagement />
    </div>
  );
}
